export const CanceledWebinarMessage = () => {
    return <span className="text-sm">This webinar has been canceled.</span>;
};
